import { IModuleConfig } from 'redux-state/layout/types.modules.js';

const formatModuleNameForSecondary = (name: string) => {
  const formattedName = name.replace(/-/g, ' ').replace(/\/\d/g, '');
  return formattedName[0]?.toUpperCase() + formattedName.slice(1);
};

export const formatStringModuleSidebar = ({ name, title }: Pick<IModuleConfig, 'name' | 'title'>) => {
  return title || formatModuleNameForSecondary(name);
};
